export const DEFAULT_SORTING = 'newest';

export const IP_API_URL = 'https://ipapi.co/json/';
export const getIpApiUrl = (ip: string) => `https://ipapi.co/${ip}/json/`;
